import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const regionCountSchema: Schema = {
  title: 'Region Count',
  level: 1,
  columns: commonColumns
}
